/**
 * Merge-tier picture URLs. The creatures are drawn in code (render/toon/creatures/) at the
 * size of the PNGs they replaced.
 */
import { TIER_ART_SIZES, tierArtKey } from "../render/toon/art-catalog.js";
import { getToonArtUrl } from "../render/toon/art-registry.js";

/**
 * @param {string} assetId
 * @returns {string}
 */
export function mergeTierImageUrl(assetId) {
  var id = String(assetId || "").trim();
  if (!id || !TIER_ART_SIZES[id]) return "";
  return getToonArtUrl(tierArtKey(id));
}

/**
 * @param {string[]} assetIds
 * @returns {string[]}
 */
export function mergeTierImageUrls(assetIds) {
  var seen = {};
  var out = [];
  for (var i = 0; i < assetIds.length; i++) {
    var url = mergeTierImageUrl(assetIds[i]);
    if (!url || seen[url]) continue;
    seen[url] = true;
    out.push(url);
  }
  return out;
}

/** @returns {string[]} */
export function allBundledMergeTierImageUrls() {
  return Object.keys(TIER_ART_SIZES).map(function (key) {
    return mergeTierImageUrl(key);
  });
}
